/**
 * isAuthError.js
 *
 * Shared utility to detect authentication/authorisation errors from
 * Supabase query responses. Centralises the detection logic so all
 * pages react consistently to expired sessions.
 *
 * @param {object|null} error - The error object returned by a Supabase query
 * @returns {boolean}
 */
export const isAuthError = (error) => {
  if (!error) return false;
  if (error?.code === 'PGRST301') return true;
  if ([401, 403]?.includes(error?.status)) return true;
  const msg = error?.message?.toLowerCase() || '';
  return ['jwt', 'auth', 'unauthorized']?.some((k) => msg?.includes(k));
};
